export enum ObjectiveType {
  INSTALL = "100",
  CHECK = "101",
  MAINTENANCE = "102",
  TAPE_BACKUP = "103",
  FIX_INCIDENT = "104",
  INTERNAL_AUDIT = "105",
  OTHER = "106"
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/objective-type.ts